module.exports = __webpack_public_path__ + "static/img/jiaobiao.19cb7f63.png";